import { HttpClient, HttpResponseBase } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { SltMasterEndpoints } from '../end-points/slt-master.class';
import { SLT_MASTER_ORDER_API_BASE_URL } from '../config/api.domains';

const FIND_PROPERTY = '/slt/api/master/secure/jas/reference/property/find-property';
const FIND_DOCUMENT_TYPE = '/slt/api/master/secure/jas/document/get-document-types';


@Injectable({
  providedIn: 'root'
})
export class PropertyLookupService {
  private readonly businessSegmentId = 2;
  private masterBaseUrl = inject(SLT_MASTER_ORDER_API_BASE_URL);
  constructor(private http: HttpClient) {}

  getPropertyByType(propertyType: string): Observable<any> {
    return this.getPropertiesByType(propertyType).pipe(
      map((res: any) => res.data)
    );
  }

  getPropertiesByType(propertyType: string): Observable<any> {
    return this.http.get(`${FIND_PROPERTY}`, {
      params: {
        businessSegmentId: this.businessSegmentId.toString(),
        propertyType
      }
    });
  }

  getPropertiesByTypeId(businessSegmentId: number, propertyType: string): Observable<any> {
    return this.http.get(`${FIND_PROPERTY}`, {
      params: {
        businessSegmentId: businessSegmentId.toString(),
        propertyType
      }
    });
  }
  getDocumentType(): Observable<any> {
    return this.http.get(`${FIND_DOCUMENT_TYPE}`);
  }
  getReasonCodes(payload: any) {
    return this.http.post<HttpResponseBase>(`${this.masterBaseUrl}reasoncode/find-reason-codes?${payload}`, '');
  }

  /** External endpoints start */
  getCarloadKeyValueExternal(keyName: string): Observable<HttpResponseBase> {
    const locationSearch = {
      keyType: keyName,
    };
    return this.http.post<HttpResponseBase>(
      `${SltMasterEndpoints.FIND_KEY_VALUE}`,
      locationSearch
    );
  }
  /** External endpoints end */
}
